import type { ReactNode } from 'react'
import { Button } from '@/components/ui/Button'
import { AuthProvider } from '@/app/providers/AuthProvider'
import { Sentry, isObservabilityEnabled } from '@/lib/observability/sentry'

type AppProvidersProps = {
  children: ReactNode
}

function AppErrorFallback() {
  return (
    <section className="card" role="alert" aria-live="polite">
      <h1 className="card-title">Something went wrong</h1>
      <p className="card-text">The page failed to render. Try refreshing the page.</p>
      <Button variant="primary" onClick={() => window.location.reload()}>
        Reload page
      </Button>
    </section>
  )
}

export function AppProviders({ children }: AppProvidersProps) {
  const content = <AuthProvider>{children}</AuthProvider>
  if (!isObservabilityEnabled()) {
    return content
  }
  return (
    <Sentry.ErrorBoundary fallback={<AppErrorFallback />} showDialog={false}>
      {content}
    </Sentry.ErrorBoundary>
  )
}
